import startCase from "lodash/startCase";

/** Omits missing API values while retaining meaningful zero and false values. */
export function getDetailEntries(value, prefix = "") {
  if (!value || typeof value !== "object") return [];
  return Object.entries(value).flatMap(([key, field]) => {
    if (field === null || field === undefined || field === "" || field === "N/A") return [];
    const name =
      { ip: "IP address", pan: "Card number", userDevice: "Device", userAgent: "Browser" }[key] ||
      startCase(key);
    const label = prefix ? `${prefix} / ${name}` : name;
    if (typeof field === "object") return getDetailEntries(field, label);
    return [[label, typeof field === "boolean" ? (field ? "Yes" : "No") : field]];
  });
}

/** Uses currency precision without rounding away additional precision returned by the API. */
export function formatTransactionAmount(amount, currency) {
  if (amount === null || amount === undefined || amount === "" || !Number.isFinite(Number(amount)))
    return "—";
  let minimumFractionDigits = 2;
  try {
    minimumFractionDigits = new Intl.NumberFormat("en", {
      style: "currency",
      currency,
    }).resolvedOptions().minimumFractionDigits;
  } catch {
    // Unknown currencies keep a readable numeric amount.
  }
  return new Intl.NumberFormat("en", { minimumFractionDigits, maximumFractionDigits: 20 }).format(
    Number(amount)
  );
}
